/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_Continue_MetaInputs */

const en_us2_search_action_continue_meta = /** @type {(inputs: Search_Action_Continue_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workout is in progress`)
};

const pt_br2_search_action_continue_meta = /** @type {(inputs: Search_Action_Continue_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu treino está em andamento`)
};

const es_419_search_action_continue_meta = /** @type {(inputs: Search_Action_Continue_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenamiento está en curso`)
};

const pt_pt2_search_action_continue_meta = /** @type {(inputs: Search_Action_Continue_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treino está a decorrer`)
};

const fr_fr2_search_action_continue_meta = /** @type {(inputs: Search_Action_Continue_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta séance est en cours`)
};

const de_de2_search_action_continue_meta = /** @type {(inputs: Search_Action_Continue_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Training läuft`)
};

const it_it2_search_action_continue_meta = /** @type {(inputs: Search_Action_Continue_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo allenamento è in corso`)
};

/**
* | output |
* | --- |
* | "Your workout is in progress" |
*
* @param {Search_Action_Continue_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_continue_meta = /** @type {((inputs?: Search_Action_Continue_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Continue_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_continue_meta(inputs)
	if (locale === "es-419") return es_419_search_action_continue_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_continue_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_continue_meta(inputs)
	if (locale === "de-DE") return de_de2_search_action_continue_meta(inputs)
	if (locale === "it-IT") return it_it2_search_action_continue_meta(inputs)
	return en_us2_search_action_continue_meta(inputs)
});
export { search_action_continue_meta as "search.action_continue_meta" }